var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4H8.5C7.65625 4 7 4.6875 7 5.5V7H5.5C4.65625 7 4 7.6875 4 8.5V18.5C4 19.3438 4.65625 20 5.5 20H15.5C16.3125 20 17 19.3438 17 18.5V17H18.5C19.3125 17 20 16.3438 20 15.5V5.5C20 4.6875 19.3125 4 18.5 4ZM15.3125 18.5H5.6875C5.5625 18.5 5.5 18.4375 5.5 18.3125V8.6875C5.5 8.59375 5.5625 8.5 5.6875 8.5H7V15.5C7 16.3438 7.65625 17 8.5 17H15.5V18.3125C15.5 18.4375 15.4062 18.5 15.3125 18.5ZM18.3125 15.5H8.6875C8.5625 15.5 8.5 15.4375 8.5 15.3125V5.6875C8.5 5.59375 8.5625 5.5 8.6875 5.5H18.3125C18.4062 5.5 18.5 5.59375 18.5 5.6875V15.3125C18.5 15.4375 18.4062 15.5 18.3125 15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.9b182dffa451c51ca21b2f008ea0e502.svg";
export { ForwardRef as ReactComponent };